import React from 'react';
import InputLabel from "@material-ui/core/InputLabel";
import NumericInput from "react-numeric-input";
import "./Quantity.scss";

function Quantity(props) {

  const {configuration,createItem,setNextEnabled} = props;

  if(!configuration["quantity"]){
    handleChange(null, 1);
  }

  function handleChange(event, value) {

    setNextEnabled(true);

    if(configuration["configurations"] == "Blank"){
      createItem({id:"tlf",value:configuration.length * value})
    }else if(configuration["configurations"] == "S"){
      //Square: Multiply side value by 4 for linear feet
      createItem({id:"tlf",value:( (parseInt(configuration.sideA) * 4) ) * value}) 
    }else if(configuration["configurations"] == "R"){
      //Rect: Multiply each side value by 2 and add for linear feet
      createItem({id:"tlf",value:( (parseInt(configuration.sideA) * 2) + (parseInt(configuration.sideB) * 2)) * value})
    }else{
      createItem({id:"tlf",value:(parseInt(configuration.sideA) + parseInt(configuration.sideB) + parseInt(configuration.sideC)) * value})
    }

    createItem({id:"quantity",value:value});
    
  }

  return (
    <React.Fragment>
      <br/>
      <div className="skuCardInputs">
        <div className="skuQuantity">
        <NumericInput
                className="form-control"
                min={1}
                max={100}
                defaultValue={configuration["quantity"] ? configuration["quantity"] : 1}
                onChange={handleChange}
              />
        </div>
        <div className="skuFeet">
            <InputLabel>Total Linear Feet:</InputLabel>
            <div className="skuFeetValue">{configuration["configurations"] != "C" ? configuration["tlf"] : "N/A"}</div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Quantity;









